import React, { useMemo } from 'react'

import { Icon, MailFilled } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf, bool, func, number, string,
} from 'prop-types'

import { iconSize } from 'Pods/LazyLoaded/AuthModal/constants'
import i18n from 'Pods/Shared/I18n'

import ErrorMessage from './Components/ErrorMessage/ErrorMessage'
import Inputs from './Components/Inputs/Inputs'
import Resend from './Components/Resend/Resend'

function CodeStep({
  email,
  digits,
  hasError,
  resendSecondsLeft,
  locale = 'en',
  onDigitsChange,
  onResend,
  onChangeEmail,
}) {
  const maskedEmail = useMemo(() => email.trim(), [email])
  const t = key => i18n.t(`auth_modal.code.${key}`, { ns: 'rails', lng: locale })

  return (
    <div className="auth-modal__code">
      <span className="auth-modal__code-icon">
        <Icon svgComponent={MailFilled} size={iconSize} notSpaced />
      </span>
      <div className="auth-modal__header-group auth-modal__header-group--center">
        <p className="auth-modal__title cgt-heading-300">{t('title')}</p>
        <p className="auth-modal__subtitle cgt-body-md">
          {/* Prefix/suffix carry their own spacing so locales where the email
              sits mid-sentence (de, ja) stay grammatical. */}
          {t('subtitle_prefix')}
          {maskedEmail ? (
            <span className="auth-modal__email cgt-body-md-semibold">{maskedEmail}</span>
          ) : (
            t('email_fallback')
          )}
          {t('subtitle_suffix')}
        </p>
      </div>
      <Inputs digits={digits} hasError={hasError} locale={locale} onDigitsChange={onDigitsChange} />
      <ErrorMessage hasError={hasError} locale={locale} />
      <Resend
        secondsLeft={resendSecondsLeft}
        locale={locale}
        onResend={onResend}
        onChangeEmail={onChangeEmail}
      />
    </div>
  )
}

CodeStep.propTypes = {
  email: string.isRequired,
  digits: arrayOf(string).isRequired,
  hasError: bool.isRequired,
  resendSecondsLeft: number.isRequired,
  locale: string,
  onDigitsChange: func.isRequired,
  onResend: func.isRequired,
  onChangeEmail: func.isRequired,
}

export default CodeStep
